import apiProcess from "../../api/utility";
import { exportSweep, importSweep, getExportSweepExcel, getSweepExcelLog } from "../../api/v2/experimentCtrl";

function exportSweepPromise(baseVerificationId) {
  return apiProcess(exportSweep, baseVerificationId);
}

function getExportSweepExcelFile({ baseVerificationId, key }) {
  return apiProcess(getExportSweepExcel, { baseVerificationId, key });
}

function getSierraSweepExcelLog({ baseVerificationId, key }) {
  return apiProcess(getSweepExcelLog, { baseVerificationId, key });
}

function importSweepPromise({ baseVerificationId, file }) {
  return apiProcess(importSweep, { baseVerificationId, file });
}

const EXPORT_RUNNING = 1, EXPORT_SUCCESS = 2, EXPORT_FAILED = 3;
export {
  exportSweepPromise,
  importSweepPromise,
  EXPORT_RUNNING,
  EXPORT_SUCCESS,
  EXPORT_FAILED,
  getExportSweepExcelFile,
  getSierraSweepExcelLog
}